import { render, staticRenderFns } from "./Feeding.vue?vue&type=template&id=71d95c1d&scoped=true&"
import script from "./Feeding.vue?vue&type=script&lang=js&"
export * from "./Feeding.vue?vue&type=script&lang=js&"
import style0 from "./Feeding.vue?vue&type=style&index=0&id=71d95c1d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d95c1d",
  null
  
)

export default component.exports